







































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { helpers, maxLength, minLength, required, sameAs } from 'vuelidate/lib/validators'
import controller from '@/app/ui/controllers/SettingController'
import Button from '@/app/ui/components/Button/index.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import Loading from '@/app/ui/components/Loading/index.vue'
import SettingTextInput from '../components/SettingTextInput/index.vue'
import { EventBus, EventBusConstants, LocalStorage, Utils } from '@/app/infrastructures/misc'
import { recaptchaV3 } from '@/app/infrastructures/misc/RecaptchaV3'
import { ExchangeOTPRequest, RequestLibertaOTP } from '@/data/payload/api/AuthRequest'
import authController from '@/app/ui/controllers/AuthController'
import VerifyOTPModal from '@/app/ui/views/Login/components/VerifyOTPModal/index.vue'
import BadgeSuccess from '../../../assets/badge_success.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import IconCheckCircle from '@/app/ui/assets/ics_f_check_circle.vue'
import CloseCircle from '@/app/ui/assets/x-circle.vue'

// Custom validator for uppercase letters
const containsUppercase = helpers.regex('containsUppercase', /[A-Z]/);

// Custom validator for numbers
const containsNumber = helpers.regex('containsNumber', /[0-9]/);

// Custom validator for symbols
const containsSymbol = helpers.regex('containsSymbol', /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/);

const notSameAs = (compareWith: string) => (value: string) => value !== compareWith;

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    TextInput,
    Loading,
    Modal,
    SettingTextInput,
    VerifyOTPModal,
    BadgeSuccess,
    LoadingOverlay,
    IconCheckCircle,
    CloseCircle
  },
})
export default class AccountSettingPage extends Vue {
  controller = controller
  successModal = false
  form = {
    currentPass: '',
    newPass: '',
    confirmPass: '',
  }
  hasChanged = {
    currentPass: false,
    newPass: false,
    confirmPass: false,
  }
  authController = authController;
  updatePasswordLoading = false;
  verifyOTPModal = false;
  verifyOTPModalLoading = false;
  otpErrorMessage = "";
  otpEmail = "";
  otpId = 0;
  otpToken = "";
  isErrorChangePassword = false;
  myEmail = "";
  myRole = "";

  created() {
    this.myEmail = LocalStorage.getLocalStorage(
      LocalStorage.LOGIN_IDENTITY,
      true
    )
    this.myRole = LocalStorage.getLocalStorage(LocalStorage.MY_ROLE, true)
    EventBus.$on(EventBusConstants.CHANGE_PASSWORD_SUCCESS, () => {
      this.successModal = true
    })
    EventBus.$on(EventBusConstants.CHANGE_PASSWORD_ERROR, (response: boolean) => {
      this.isErrorChangePassword = response;
    })
  }

  @Validations()
  validations() {
    let validate = {
      form: {
        currentPass: { required },
        newPass: { 
          required,
          maxLength: maxLength(72),
          minLength: minLength(8),
          containsUppercase,
          containsNumber,
          containsSymbol,
          notSameAsCurrentPass: notSameAs(this.form.currentPass),
         },
        confirmPass: { required, sameAsPassword: sameAs('newPass') },
      },
    }

    return validate
  }

  private onChangePassword() {
    controller.changePassword({
      ...this.form,
      token: this.otpToken
    })
  }

  private onCloseSuccessModal() {
    this.successModal = false
    this.resetAll()
    this.isErrorChangePassword = false;
  }

  private resetAll() {
    this.form = {
      currentPass: '',
      newPass: '',
      confirmPass: '',
    }
    this.hasChanged = {
      currentPass: false,
      newPass: false,
      confirmPass: false,
    }
    this.otpErrorMessage = "";
    this.otpEmail = "";
    this.otpId = 0;
    this.otpToken = "";
    
    LocalStorage.removeAllLocalStorage();
    this.$router.replace("/");
  }

  beforeDestroy() {
    EventBus.$off(EventBusConstants.CHANGE_PASSWORD_SUCCESS)
    EventBus.$off(EventBusConstants.CHANGE_PASSWORD_ERROR)
  }
  
  public async onUpdatePassword(): Promise<void> {
    if (this.isErrorChangePassword) {
      this.onChangePassword();
      return
    }
    try {
    this.updatePasswordLoading = true
    const token = await recaptchaV3.executeRecaptcha()
    const payload = new RequestLibertaOTP({
      email: this.myEmail,
      otpType: "PASSWORD_CHANGE",
      messagingType: "EMAIL",
      role: this.myRole,
      token,
    })
      const resp = await authController.requestLibertaOTP(payload);
      this.verifyOTPModal = true;
      this.updatePasswordLoading = false;
      this.otpEmail = Utils.maskEmail(this.myEmail);
      this.otpId = resp.otpId
      localStorage.removeItem("otp-countdown")
      await this.$nextTick();
      EventBus.$emit(EventBusConstants.RESET_VERIFY_OTP_MODAL, resp.expiredIn);
    } catch (error) {
      // error
      Vue.notify({
        title: 'Request OTP Failed',
        text: error.data.message.id,
        type: 'error',
        duration: 5000,
      })
    } finally {
      this.updatePasswordLoading = false;
    }
  }

  public async onVerifyOTP(otp = ""): Promise<void> {
    try {
      this.otpErrorMessage = "";
      this.verifyOTPModalLoading = true;
      const payload = new ExchangeOTPRequest({
        otp,
        otpId: this.otpId
      })
      const resp = await authController.exchangeOTP(payload);
      this.otpToken = resp;
      this.verifyOTPModal = false;
      this.onChangePassword();
    } catch (error) {
      this.otpErrorMessage = error.data.message.id
    } finally {
      this.verifyOTPModalLoading = false;
    }
  }

  get containsEightCharacters() {
    return this.form.newPass.length >= 8;
  }

  get containsUppercase() {
    return /[A-Z]/.test(this.form.newPass);
  }

  get containsNumber() {
    return /[0-9]/.test(this.form.newPass);
  }

  get containsSymbol() {
    return /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(this.form.newPass);
  }
}
